import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';

interface Payload {
  videoId: string;
}

const renderRemotionVideo = async (payload: Payload): Promise<any> => {
  const res = await axiosInstance.post('/api/remotion/render', payload);
  return res.data;
};

export const useRenderRemotionVideo = () => {
  return useMutation(renderRemotionVideo, { onSuccess: (data) => data });
};
